import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import axios from "axios";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import AssetDetail from "@/pages/AssetDetail";
import Portfolio from "@/pages/Portfolio";
import Learning from "@/pages/Learning";
import AuthCallback from "@/pages/AuthCallback";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Disclaimer from "@/pages/Disclaimer";
import Leaderboard from "@/pages/Leaderboard";
import Admin from "@/pages/Admin";
import AlertsHub from "@/pages/AlertsHub";
import Settings from "@/pages/Settings";
import ShareView from "@/pages/ShareView";
import ResetPassword from "@/pages/ResetPassword";
import { Toaster } from "@/components/ui/sonner";
import InstallAppBanner from "@/components/InstallAppBanner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

function AppRouter() {
  const location = useLocation();

  // Capture referral code from any landing URL (?ref=CODE) for signup attribution
  useEffect(() => {
    const ref = new URLSearchParams(location.search).get("ref");
    if (ref) sessionStorage.setItem("ref_code", ref);
  }, [location.search]);

  // CRITICAL: Detect session_id in hash synchronously during render (not in useEffect)
  // This prevents race conditions with AuthProvider's checkAuth
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/asset/:symbol" element={<AssetDetail />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="/learning" element={<Learning />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/disclaimer" element={<Disclaimer />} />
      <Route path="/leaderboard" element={<Leaderboard />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/alerts" element={<AlertsHub />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/s/:shareId" element={<ShareView />} />
      <Route path="/reset-password" element={<ResetPassword />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster richColors position="top-right" offset={96} mobileOffset={116} />
        <InstallAppBanner />
      </div>
    </AuthProvider>
  );
}

export default App;
